import { ApiConfig } from './api';
import { fetchWrapper } from './utils/http-utils';
import { FREQUENCY_ENUM } from '../enums';
import { Universe } from '../types/universe';

type ValidDatesDataType = {
  frequency: FREQUENCY_ENUM;

  universe_id?: number;
  countries?: string[];
  start_date?: string;
  end_date?: string;
  ignore_cache?: boolean;
  until_latest_trade_date?: boolean;
};

type KeepCurrentDataType = {
  resource_id: number;
  resource_type: string;
  max_date: string;

  countries?: string[];
  universe_id?: number;
  frequency?: FREQUENCY_ENUM;
};

export const get_valid_dates =
  (config: ApiConfig) =>
  (data: ValidDatesDataType): Promise<{ data: string[] }> =>
    fetchWrapper<{ data: string[] }>(
      `${config.endpoint}get_valid_dates`,
      {
        method: 'POST',
        body: JSON.stringify({ ...data }),
      },
      config
    );

export const keep_current =
  (config: ApiConfig) =>
  (data: KeepCurrentDataType): Promise<{ resource: any; universe?: Universe }> =>
    fetchWrapper<{ resource: any; universe?: Universe }>(
      `${config.endpoint}resource_keep_current`,
      {
        method: 'POST',
        body: JSON.stringify({ ...data }),
      },
      config
    );
